class ShowMoreContent extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.dataIndex = parseInt(this.getAttribute("data-current"));
    this.dataMax = parseInt(this.getAttribute("data-max"));
    const root = this.parentElement || document;

    if (this.dataMax >= this.dataIndex) {
      root.querySelector('.description-split[data-index="' + this.dataIndex + '"]').classList.add("opening");
      this.setAttribute("data-current", this.dataIndex + 1);
      if (this.dataMax == this.dataIndex) {
        this.innerHTML = "Read less";
      }
    } else {
      root.querySelectorAll(".description-split").forEach((ele) => ele.classList.remove("opening"));
      root.querySelector('.description-split[data-index="1"]').classList.add("opening");
      this.innerHTML = "Read more";
      this.setAttribute("data-current", 2);
    }
  }
}

if (!customElements.get("showmore-content")) {
  customElements.define("showmore-content", ShowMoreContent);
}
